<template>
   	<div class="timeWrapper" style="flex: 1;">
   		<p>选择时间</p>
   		<div class="timeBox">
			<div :class="{'timeItem': true,'active':active == index}" :key="option.id" v-for="(option,index) in options" @click="canleClick(index)">{{option.name}}</div>
   		</div>
   		<p v-if="active==4">自定义时间</p>
   		<div class="customBox" v-if="active==4">
   			<van-field class="fileBorder" v-model="startTime" placeholder="开始时间" readonly @click="chooseDate('start')" ref="startTime"/>
   			<van-field class="fileBorder" v-model="endTime" placeholder="结束时间" readonly @click="chooseDate('end')" ref="endTime" />
   		</div>
		<!-- <van-button block type="info" @click="onConfirm">确认</van-button> -->
	<van-popup v-model="showPop" position="bottom" :overlay="true">
	<van-datetime-picker v-model="currentDate" type="date" @cancel="cancel" @confirm="confirm" />
	</van-popup>
   </div>
</template>
<script>
    import {Col, Row ,Sidebar, SidebarItem,DatetimePicker,Field,Popup,Button} from 'vant';
    import dictionaryService from "../service/dictionaryService";
	import {format} from "../utils/date";
	import moment from "moment";
	

    export default {
        name: 'VanFieldAcb',
        components: {
           [Col.name]: Col,
           [Row.name]: Row,
           [Popup.name]: Popup,
           [Sidebar.name]: Sidebar,
           [SidebarItem.name]: SidebarItem,
           [DatetimePicker.name]: DatetimePicker,
           [Field.name]: Field,
		   [Button.name]: Button 
        },
        data() {
            return {
				options:[
					{id:0,name:'不限'},
					{id:1,name:'昨天'},
					{id:2,name:'今天'},
					{id:3,name:'最近七天'},
					{id:4,name:'自定义'}
				],
               showPop: false,
               startTime: '',
               endTime: '' ,
			   active: this.timeType,
			   chooseTime:'',
			   format: 'yyyy-MM-dd',
			   currentDate: new Date()
            }
        },
        props: {
            timeType:{
				type: Number,
				default: 1
			}
        },
        methods: {
			canleClick(index) {
			   this.active = index;
			   if(index != 4){
				  this.startTime = '';
				  this.endTime = '';
				  this.saveData(); 
			   }  
			},
			chooseDate(type) {
			   this.chooseTime = type;
			   this.showPop = true;
			},
			confirm(value) {
			   if(this.chooseTime == 'start') {
				   this.startTime = format(value, this.format)
			   } else {
				  this.endTime = format(value, this.format) 
			   }
		       this.showPop = false;
			   if(this.startTime != '' && this.endTime != '') {
				   this.saveData();
			   }
			},
			cancel() {
		       this.showPop = false;
			},
			saveData() {
				let data = {};
				if(this.active == 0) {
					data.startTime = '';
					data.endTime = '';
				}else if(this.active == 1) {
					data.startTime = moment().subtract(1, 'days').format('YYYY-MM-DD');
					data.endTime = moment().subtract(1, 'days').format('YYYY-MM-DD');
				}
				else if(this.active == 2) {
					data.startTime = moment().format('YYYY-MM-DD');
					data.endTime = moment().format('YYYY-MM-DD');
				}
				else if(this.active == 3) {
					data.startTime = moment().subtract(7,'days').format('YYYY-MM-DD');
					data.endTime = moment().add(7,'days').format('YYYY-MM-DD');
				}else {
					data.startTime = this.startTime;
					data.endTime = this.endTime;
				}
				data.timeType = this.active;
				this.$emit('ongetdate', data);
			}
        },
        watch: {
            timeType(newValue, oldValue) {
				this.active = newValue;
			}
        },
        mounted: function () {
            
        },
        computed: {
			
		}
    }
</script>
<style>
	.fileBorder {
		padding:0 0.4rem 1rem;
	}
	.fileBorder input {
		padding:0.2rem;
		border: 2px solid #c9c9c9;
		border-radius:10px;
	}
	.timeWrapper p{
		margin:0.4rem;
		color:#6f6767;
		font-size:0.8rem;
	}
    .timeBox {
    	display: flex;
    	align-items: center;
    	flex-wrap: wrap;
    }
    .timeBox .timeItem {
    	flex: 0 0 25%;
    	text-align: center;
    	background: #F3F3F3;
    	padding:0.4rem;
    	border-radius: 4px;
		margin: 0 0.4rem;
    	margin-bottom:0.4rem;
		font-size: 0.8rem;
    }
	.active {
		background: #1890ff !important;
		color:#fff !important;
	}
	.customBox {
		display: flex;
	}
	.van-cell::after {
		position: absolute;
		box-sizing: border-box;
		content: ' ';
		pointer-events: none;
		right: 0;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #ebedf0;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}
</style>